import { useSearchParams, Link } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermFaqCategory from '@/components/TermFaqCategory';

const FaqMembershipLoginPage = () => {
  const [searchParams] = useSearchParams();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">よくあるご質問</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <TermFaqCategory />
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">会員情報・ログイン関連</div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">ログインパスワードを忘れてしまった。</div>
              <div className="w-full inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 pl-5 inline-flex flex-col justify-center items-start gap-2.5">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                    ログインパスワードは、ログイン画面より再設定が可能です。<br/>
                    ログイン中の場合には、マイページからログアウトしたうえで、ログイン画面からパスワードを再設定してください。
                  </div>
                  <div className="flex flex-col justify-start items-start">
                    <div className="w-full justify-center text-black text-base font-bold leading-7">対応手順（ウェブ版）</div>
                    <div className="w-full justify-center text-black text-base font-normal leading-7">
                      1. Webサイトの画面右上の「ログイン」をタップ<br/>
                      2. 「パスワードを忘れた方」をタップ<br/>
                      3. 「パスワードを再設定」で登録メールアドレスを入力<br/>
                      4. 「認証コードを送信」をタップ<br/>
                      5. 認証コードを入力<br/>
                      6. 新しいパスワードを入力<br/>
                      7. 「確認」をタップ
                    </div>
                  </div>
                  <div className="self-stretch flex flex-col justify-start items-start">
                    <div className="self-stretch justify-center text-black text-base font-bold leading-7">対応手順（モバイル版）</div>
                    <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                      1. 「マイページ」をタップ<br/>
                      2. 「ログイン」をタップする<br/>
                      3. 「パスワードを忘れた方」をタップ<br/>
                      4. 「パスワードを再設定」で登録メールアドレスを入力<br/>
                      5. 「認証コードを送信」をタップ<br/>
                      6. 認証コードを入力<br/>
                      7. 新しいパスワードを入力<br/>
                      8. 「確認」をタップ
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">アカウントの削除をしたい。</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  <span>DONDONをご利用いただき、ありがとうございました。個人情報の削除をご希望の場合は、マイページの</span>
                  <Link to="/contact" className="underline hover:text-[#0099d6]">お問い合わせフォーム</Link>
                  <span>からご連絡ください。ご依頼内容は確認のうえ、数日以内に対応させていただきます。</span>
                </div>
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  以下の情報をご入力ください：<br/>
                  1. 登録済みメールアドレス（必須）<br/>
                  2. 登録済み電話番号（任意）<br/>
                  3. 削除希望の詳細（必須）<br/>
                  例：アカウントと個人データの削除をお願いします。
                </div>
              </div>
            </div>
          </div>
          
          <TermFaqCategory />
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default FaqMembershipLoginPage;